import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "container image-page"
};
const _hoisted_2 = {
  class: "handle-box"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  class: "pagination"
};
const _hoisted_7 = {
  class: "handle-box"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  key: 1
};
const _hoisted_11 = {
  class: "pagination"
};
const _hoisted_12 = {
  class: "handle-box"
};
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = {
  key: 0
};
const _hoisted_15 = {
  key: 1
};
const _hoisted_16 = {
  class: "pagination"
};
import { onMounted, ref } from "vue";
import { httpGet, httpPost } from "@/utils/http";
import { ElMessage } from "element-plus";
import { dateFormat, substr } from "@/utils/libs";
import { Search } from "@element-plus/icons-vue";

// 变量定义

export default {
  __name: 'ImageList',
  setup(__props) {
    const data = ref({
      mj: {
        items: [],
        query: {
          prompt: "",
          username: "",
          created_at: [],
          page: 1,
          page_size: 15
        },
        total: 0,
        page: 1,
        pageSize: 15,
        loading: true
      },
      sd: {
        items: [],
        query: {
          prompt: "",
          username: "",
          created_at: [],
          page: 1,
          page_size: 15
        },
        total: 0,
        page: 1,
        pageSize: 15,
        loading: true
      },
      dall: {
        items: [],
        query: {
          prompt: "",
          username: "",
          created_at: [],
          page: 1,
          page_size: 15
        },
        total: 0,
        page: 1,
        pageSize: 15,
        loading: true
      }
    });
    const activeName = ref("mj");
    const taskTypeTheme = {
      image: {
        text: "绘图",
        color: "#2185d0"
      },
      upscale: {
        text: "放大",
        color: "#f2711c"
      },
      variation: {
        text: "变换",
        color: "#00b5ad"
      },
      blend: {
        text: "融图",
        color: "#21ba45"
      },
      swapFace: {
        text: "换脸",
        color: "#a333c8"
      }
    };
    onMounted(() => {
      fetchMjData();
    });
    const handleChange = tab => {
      switch (tab) {
        case "mj":
          fetchMjData();
          break;
        case "sd":
          fetchSdData();
          break;
        case "dall":
          fetchDallData();
          break;
      }
    };

    // 搜索对话
    const search = (evt, tab) => {
      if (evt.keyCode === 13) {
        handleChange(tab);
      }
    };

    // 获取数据
    const fetchMjData = () => {
      const d = data.value.mj;
      d.query.page = d.page;
      d.query.page_size = d.pageSize;
      httpPost("/admin/image/list/mj", d.query).then(res => {
        if (res.data) {
          d.items = res.data.items;
          d.total = res.data.total;
          d.page = res.data.page;
          d.pageSize = res.data.page_size;
        }
        d.loading = false;
      }).catch(e => {
        ElMessage.error("获取数据失败：" + e.message);
      });
    };
    const fetchSdData = () => {
      const d = data.value.sd;
      d.query.page = d.page;
      d.query.page_size = d.pageSize;
      httpPost("/admin/image/list/sd", d.query).then(res => {
        if (res.data) {
          d.items = res.data.items;
          d.total = res.data.total;
          d.page = res.data.page;
          d.pageSize = res.data.page_size;
        }
        d.loading = false;
      }).catch(e => {
        ElMessage.error("获取数据失败：" + e.message);
      });
    };
    const fetchDallData = () => {
      const d = data.value.dall;
      d.query.page = d.page;
      d.query.page_size = d.pageSize;
      httpPost("/admin/image/list/dall", d.query).then(res => {
        if (res.data) {
          d.items = res.data.items;
          d.total = res.data.total;
          d.page = res.data.page;
          d.pageSize = res.data.page_size;
        }
        d.loading = false;
      }).catch(e => {
        ElMessage.error("获取数据失败：" + e.message);
      });
    };
    const remove = function (row, tab) {
      httpGet(`/api/admin/image/remove?id=${row.id}&tab=${tab}`).then(() => {
        ElMessage.success("删除成功！");
        handleChange(tab);
      }).catch(e => {
        ElMessage.error("删除失败：" + e.message);
      });
    };
    const showImageDialog = ref(false);
    const imgURL = ref("");
    const showImage = url => {
      showImageDialog.value = true;
      imgURL.value = url;
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_popover = _resolveComponent("el-popover");
      const _component_el_text = _resolveComponent("el-text");
      const _component_el_popconfirm = _resolveComponent("el-popconfirm");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_tabs, {
        modelValue: activeName.value,
        "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => activeName.value = $event),
        onTabChange: handleChange
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
          label: "Midjourney",
          name: "mj"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
            modelValue: data.value.mj.query.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.value.mj.query.username = $event),
            placeholder: "用户名",
            class: "handle-input mr10",
            onKeyup: _cache[1] || (_cache[1] = $event => search($event, 'mj')),
            clearable: ""
          }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
            modelValue: data.value.mj.query.prompt,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.value.mj.query.prompt = $event),
            placeholder: "提示词",
            class: "handle-input mr10",
            onKeyup: _cache[3] || (_cache[3] = $event => search($event, 'mj')),
            clearable: ""
          }, null, 8, ["modelValue"]), _createVNode(_component_el_date_picker, {
            modelValue: data.value.mj.query.created_at,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => data.value.mj.query.created_at = $event),
            type: "daterange",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            format: "YYYY-MM-DD",
            "value-format": "YYYY-MM-DD",
            style: {
              "margin-right": "10px",
              "width": "200px",
              "position": "relative",
              "top": "3px"
            }
          }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
            type: "primary",
            icon: _unref(Search),
            onClick: fetchMjData
          }, {
            default: _withCtx(() => _cache[26] || (_cache[26] = [_createTextVNode("搜索")])),
            _: 1
          }, 8, ["icon"])]), data.value.mj.items.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_table, {
              data: data.value.mj.items,
              "row-key": row => row.id,
              "table-layout": "auto"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                prop: "user_id",
                label: "用户ID"
              }), _createVNode(_component_el_table_column, {
                label: "任务类型"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_button, {
                  color: taskTypeTheme[scope.row.type].color,
                  size: "small",
                  plain: ""
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(taskTypeTheme[scope.row.type].text), 1)]),
                  _: 2
                }, 1032, ["color"])]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "progress",
                label: "任务进度"
              }, {
                default: _withCtx(scope => [scope.row.progress <= 100 ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(scope.row.progress) + "%", 1)) : (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  type: "danger"
                }, {
                  default: _withCtx(() => _cache[27] || (_cache[27] = [_createTextVNode("已失败")])),
                  _: 1
                }))]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "power",
                label: "消耗算力"
              }), _createVNode(_component_el_table_column, {
                label: "结果图片"
              }, {
                default: _withCtx(scope => [scope.row.img_url !== '' ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  size: "small",
                  type: "success",
                  onClick: $event => showImage(scope.row.img_url),
                  plain: ""
                }, {
                  default: _withCtx(() => _cache[28] || (_cache[28] = [_createTextVNode("预览图片")])),
                  _: 2
                }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "提示词"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_popover, {
                  placement: "top-start",
                  title: "绘画提示词",
                  width: 300,
                  trigger: "hover",
                  content: scope.row.prompt
                }, {
                  reference: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_unref(substr)(scope.row.prompt, 20)), 1)]),
                  _: 2
                }, 1032, ["content"])]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "创建时间"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_unref(dateFormat)(scope.row["created_at"])), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "失败原因"
              }, {
                default: _withCtx(scope => [scope.row.progress === 101 ? (_openBlock(), _createBlock(_component_el_popover, {
                  key: 0,
                  placement: "top-start",
                  title: "失败原因",
                  width: 300,
                  trigger: "hover",
                  content: scope.row.err_msg
                }, {
                  reference: _withCtx(() => [_createVNode(_component_el_text, {
                    type: "danger"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(substr)(scope.row.err_msg, 20)), 1)]),
                    _: 2
                  }, 1024)]),
                  _: 2
                }, 1032, ["content"])) : (_openBlock(), _createElementBlock("span", _hoisted_5, "无"))]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "操作",
                width: "180"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_popconfirm, {
                  title: "确定要删除当前记录吗?",
                  onConfirm: $event => remove(scope.row, 'mj')
                }, {
                  reference: _withCtx(() => [_createVNode(_component_el_button, {
                    size: "small",
                    type: "danger"
                  }, {
                    default: _withCtx(() => _cache[29] || (_cache[29] = [_createTextVNode("删除")])),
                    _: 1
                  })]),
                  _: 2
                }, 1032, ["onConfirm"])]),
                _: 1
              })]),
              _: 1
            }, 8, ["data", "row-key"])]),
            _: 1
          }), _createElementVNode("div", _hoisted_6, [data.value.mj.total > 0 ? (_openBlock(), _createBlock(_component_el_pagination, {
            key: 0,
            background: "",
            layout: "total,prev, pager, next",
            "hide-on-single-page": true,
            "current-page": data.value.mj.page,
            "onUpdate:currentPage": _cache[5] || (_cache[5] = $event => data.value.mj.page = $event),
            "page-size": data.value.mj.pageSize,
            "onUpdate:pageSize": _cache[6] || (_cache[6] = $event => data.value.mj.pageSize = $event),
            onCurrentChange: _cache[7] || (_cache[7] = $event => fetchMjData()),
            total: data.value.mj.total
          }, null, 8, ["current-page", "page-size", "total"])) : _createCommentVNode("", true)])])) : (_openBlock(), _createBlock(_component_el_empty, {
            key: 1
          }))]),
          _: 1
        })), [[_directive_loading, data.value.mj.loading]]), _withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
          label: "Stable-Diffusion",
          name: "sd"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_input, {
            modelValue: data.value.sd.query.username,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => data.value.sd.query.username = $event),
            placeholder: "用户名",
            class: "handle-input mr10",
            onKeyup: _cache[9] || (_cache[9] = $event => search($event, 'sd')),
            clearable: ""
          }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
            modelValue: data.value.sd.query.prompt,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => data.value.sd.query.prompt = $event),
            placeholder: "提示词",
            class: "handle-input mr10",
            onKeyup: _cache[11] || (_cache[11] = $event => search($event, 'sd')),
            clearable: ""
          }, null, 8, ["modelValue"]), _createVNode(_component_el_date_picker, {
            modelValue: data.value.sd.query.created_at,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => data.value.sd.query.created_at = $event),
            type: "daterange",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            format: "YYYY-MM-DD",
            "value-format": "YYYY-MM-DD",
            style: {
              "margin-right": "10px",
              "width": "200px",
              "position": "relative",
              "top": "3px"
            }
          }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
            type: "primary",
            icon: _unref(Search),
            onClick: fetchSdData
          }, {
            default: _withCtx(() => _cache[30] || (_cache[30] = [_createTextVNode("搜索")])),
            _: 1
          }, 8, ["icon"])]), data.value.sd.items.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_table, {
              data: data.value.sd.items,
              "row-key": row => row.id,
              "table-layout": "auto"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                prop: "user_id",
                label: "用户ID"
              }), _createVNode(_component_el_table_column, {
                prop: "progress",
                label: "任务进度"
              }, {
                default: _withCtx(scope => [scope.row.progress <= 100 ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(scope.row.progress) + "%", 1)) : (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  type: "danger"
                }, {
                  default: _withCtx(() => _cache[31] || (_cache[31] = [_createTextVNode("已失败")])),
                  _: 1
                }))]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "power",
                label: "消耗算力"
              }), _createVNode(_component_el_table_column, {
                label: "结果图片"
              }, {
                default: _withCtx(scope => [scope.row.img_url !== '' ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  size: "small",
                  type: "success",
                  onClick: $event => showImage(scope.row.img_url),
                  plain: ""
                }, {
                  default: _withCtx(() => _cache[32] || (_cache[32] = [_createTextVNode("预览图片")])),
                  _: 2
                }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "提示词"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_popover, {
                  placement: "top-start",
                  title: "绘画提示词",
                  width: 300,
                  trigger: "hover",
                  content: scope.row.prompt
                }, {
                  reference: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_unref(substr)(scope.row.prompt, 20)), 1)]),
                  _: 2
                }, 1032, ["content"])]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "创建时间"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_unref(dateFormat)(scope.row["created_at"])), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "失败原因"
              }, {
                default: _withCtx(scope => [scope.row.progress === 101 ? (_openBlock(), _createBlock(_component_el_popover, {
                  key: 0,
                  placement: "top-start",
                  title: "失败原因",
                  width: 300,
                  trigger: "hover",
                  content: scope.row.err_msg
                }, {
                  reference: _withCtx(() => [_createVNode(_component_el_text, {
                    type: "danger"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(substr)(scope.row.err_msg, 20)), 1)]),
                    _: 2
                  }, 1024)]),
                  _: 2
                }, 1032, ["content"])) : (_openBlock(), _createElementBlock("span", _hoisted_10, "无"))]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "操作",
                width: "180"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_popconfirm, {
                  title: "确定要删除当前记录吗?",
                  onConfirm: $event => remove(scope.row, 'sd')
                }, {
                  reference: _withCtx(() => [_createVNode(_component_el_button, {
                    size: "small",
                    type: "danger"
                  }, {
                    default: _withCtx(() => _cache[33] || (_cache[33] = [_createTextVNode("删除")])),
                    _: 1
                  })]),
                  _: 2
                }, 1032, ["onConfirm"])]),
                _: 1
              })]),
              _: 1
            }, 8, ["data", "row-key"])]),
            _: 1
          }), _createElementVNode("div", _hoisted_11, [data.value.sd.total > 0 ? (_openBlock(), _createBlock(_component_el_pagination, {
            key: 0,
            background: "",
            layout: "total,prev, pager, next",
            "hide-on-single-page": true,
            "current-page": data.value.sd.page,
            "onUpdate:currentPage": _cache[13] || (_cache[13] = $event => data.value.sd.page = $event),
            "page-size": data.value.sd.pageSize,
            "onUpdate:pageSize": _cache[14] || (_cache[14] = $event => data.value.sd.pageSize = $event),
            onCurrentChange: _cache[15] || (_cache[15] = $event => fetchSdData()),
            total: data.value.sd.total
          }, null, 8, ["current-page", "page-size", "total"])) : _createCommentVNode("", true)])])) : (_openBlock(), _createBlock(_component_el_empty, {
            key: 1
          }))]),
          _: 1
        })), [[_directive_loading, data.value.sd.loading]]), _createVNode(_component_el_tab_pane, {
          label: "DALL-E",
          name: "dall"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_input, {
            modelValue: data.value.dall.query.username,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => data.value.dall.query.username = $event),
            placeholder: "用户名",
            class: "handle-input mr10",
            onKeyup: _cache[17] || (_cache[17] = $event => search($event, 'dall')),
            clearable: ""
          }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
            modelValue: data.value.dall.query.prompt,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => data.value.dall.query.prompt = $event),
            placeholder: "提示词",
            class: "handle-input mr10",
            onKeyup: _cache[19] || (_cache[19] = $event => search($event, 'dall')),
            clearable: ""
          }, null, 8, ["modelValue"]), _createVNode(_component_el_date_picker, {
            modelValue: data.value.dall.query.created_at,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => data.value.dall.query.created_at = $event),
            type: "daterange",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            format: "YYYY-MM-DD",
            "value-format": "YYYY-MM-DD",
            style: {
              "margin-right": "10px",
              "width": "200px",
              "position": "relative",
              "top": "3px"
            }
          }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
            type: "primary",
            icon: _unref(Search),
            onClick: fetchDallData
          }, {
            default: _withCtx(() => _cache[34] || (_cache[34] = [_createTextVNode("搜索")])),
            _: 1
          }, 8, ["icon"])]), data.value.dall.items.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_table, {
              data: data.value.dall.items,
              "row-key": row => row.id,
              "table-layout": "auto"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                prop: "user_id",
                label: "用户ID"
              }), _createVNode(_component_el_table_column, {
                prop: "progress",
                label: "任务进度"
              }, {
                default: _withCtx(scope => [scope.row.progress <= 100 ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(scope.row.progress) + "%", 1)) : (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  type: "danger"
                }, {
                  default: _withCtx(() => _cache[35] || (_cache[35] = [_createTextVNode("已失败")])),
                  _: 1
                }))]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "power",
                label: "消耗算力"
              }), _createVNode(_component_el_table_column, {
                label: "结果图片"
              }, {
                default: _withCtx(scope => [scope.row.img_url !== '' ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  size: "small",
                  type: "success",
                  onClick: $event => showImage(scope.row.img_url),
                  plain: ""
                }, {
                  default: _withCtx(() => _cache[36] || (_cache[36] = [_createTextVNode("预览图片")])),
                  _: 2
                }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "提示词"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_popover, {
                  placement: "top-start",
                  title: "绘画提示词",
                  width: 300,
                  trigger: "hover",
                  content: scope.row.prompt
                }, {
                  reference: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_unref(substr)(scope.row.prompt, 20)), 1)]),
                  _: 2
                }, 1032, ["content"])]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "创建时间"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_unref(dateFormat)(scope.row["created_at"])), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "失败原因"
              }, {
                default: _withCtx(scope => [scope.row.progress === 101 ? (_openBlock(), _createBlock(_component_el_popover, {
                  key: 0,
                  placement: "top-start",
                  title: "失败原因",
                  width: 300,
                  trigger: "hover",
                  content: scope.row.err_msg
                }, {
                  reference: _withCtx(() => [_createVNode(_component_el_text, {
                    type: "danger"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(substr)(scope.row.err_msg, 20)), 1)]),
                    _: 2
                  }, 1024)]),
                  _: 2
                }, 1032, ["content"])) : (_openBlock(), _createElementBlock("span", _hoisted_15, "无"))]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "操作",
                width: "180"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_popconfirm, {
                  title: "确定要删除当前记录吗?",
                  onConfirm: $event => remove(scope.row, 'dall')
                }, {
                  reference: _withCtx(() => [_createVNode(_component_el_button, {
                    size: "small",
                    type: "danger"
                  }, {
                    default: _withCtx(() => _cache[37] || (_cache[37] = [_createTextVNode("删除")])),
                    _: 1
                  })]),
                  _: 2
                }, 1032, ["onConfirm"])]),
                _: 1
              })]),
              _: 1
            }, 8, ["data", "row-key"])]),
            _: 1
          }), _createElementVNode("div", _hoisted_16, [data.value.dall.total > 0 ? (_openBlock(), _createBlock(_component_el_pagination, {
            key: 0,
            background: "",
            layout: "total,prev, pager, next",
            "hide-on-single-page": true,
            "current-page": data.value.dall.page,
            "onUpdate:currentPage": _cache[21] || (_cache[21] = $event => data.value.dall.page = $event),
            "page-size": data.value.dall.pageSize,
            "onUpdate:pageSize": _cache[22] || (_cache[22] = $event => data.value.dall.pageSize = $event),
            onCurrentChange: _cache[23] || (_cache[23] = $event => fetchDallData()),
            total: data.value.dall.total
          }, null, 8, ["current-page", "page-size", "total"])) : _createCommentVNode("", true)])])) : (_openBlock(), _createBlock(_component_el_empty, {
            key: 1
          }))]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: showImageDialog.value,
        "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => showImageDialog.value = $event),
        title: "图片预览"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_image, {
          src: imgURL.value,
          "zoom-rate": 1.2,
          "max-scale": 7,
          "min-scale": 0.2,
          "preview-src-list": [imgURL.value],
          "initial-index": 0,
          fit: "cover"
        }, null, 8, ["src", "preview-src-list"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};